"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _ApiClient = _interopRequireDefault(require("../ApiClient"));
var _CreateSchema = _interopRequireDefault(require("../model/CreateSchema"));
var _UpdateSchema = _interopRequireDefault(require("../model/UpdateSchema"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
/**
* Schemas service.
* @module api/SchemasApi
* @version 0.1.0
*/
var SchemasApi = /*#__PURE__*/function () {
  /**
  * Constructs a new SchemasApi. 
  * @alias module:api/SchemasApi
  * @class
  * @param {module:ApiClient} [apiClient] Optional API client implementation to use,
  * default to {@link module:ApiClient#instance} if unspecified.
  */
  function SchemasApi(apiClient) {
    _classCallCheck(this, SchemasApi);
    this.apiClient = apiClient || _ApiClient["default"].instance;
  }

  /**
   * @param {Object} opts Optional parameters
   * @param {module:model/CreateSchema} opts.createSchema Payload for creating a new schema.
   * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link Object} and HTTP response
   */
  _createClass(SchemasApi, [{
    key: "createWithHttpInfo",
    value: function createWithHttpInfo(opts) {
      opts = opts || {};
      var postBody = opts['createSchema'];
      var pathParams = {};
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['ApiAuthorizer', 'ApiKey'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = Object;
      return this.apiClient.callApi('/schemas/', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/CreateSchema} opts.createSchema Payload for creating a new schema.
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link Object}
     */
  }, {
    key: "create",
    value: function create(opts) {
      return this.createWithHttpInfo(opts).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * @param {Number} id 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link Object} and HTTP response
     */
  }, {
    key: "getWithHttpInfo",
    value: function getWithHttpInfo(id) {
      var postBody = null;
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling get");
      }
      var pathParams = {
        'id': id
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['ApiAuthorizer', 'ApiKey'];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = Object;
      return this.apiClient.callApi('/schemas/{id}', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * @param {Number} id 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link Object}
     */
  }, {
    key: "get",
    value: function get(id) {
      return this.getWithHttpInfo(id).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * @param {Number} id 
     * @param {Object} opts Optional parameters
     * @param {Number} opts.page Page of results to return.
     * @param {Number} opts.limit Limit of results to return.
     * @param {Number} opts.status Filter results by status.
     * @param {String} opts.name Filter results by name.
     * @param {String} opts.email Filter results by email.
     * @param {String} opts.state Filter results by state.
     * @param {String} opts.country Filter results by country.
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link Object} and HTTP response
     */
  }, {
    key: "getContractorsWithHttpInfo",
    value: function getContractorsWithHttpInfo(id, opts) {
      opts = opts || {};
      var postBody = null;
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling getContractors");
      }
      var pathParams = {
        'id': id
      };
      var queryParams = {
        'page': opts['page'],
        'limit': opts['limit'],
        'status': opts['status'],
        'name': opts['name'],
        'email': opts['email'],
        'state': opts['state'],
        'country': opts['country']
      };
      var headerParams = {};
      var formParams = {};
      var authNames = ['ApiAuthorizer', 'ApiKey'];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = Object;
      return this.apiClient.callApi('/schemas/{id}/contractors', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * @param {Number} id 
     * @param {Object} opts Optional parameters
     * @param {Number} opts.page Page of results to return.
     * @param {Number} opts.limit Limit of results to return.
     * @param {Number} opts.status Filter results by status.
     * @param {String} opts.name Filter results by name.
     * @param {String} opts.email Filter results by email.
     * @param {String} opts.state Filter results by state.
     * @param {String} opts.country Filter results by country.
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link Object}
     */
  }, {
    key: "getContractors",
    value: function getContractors(id, opts) {
      return this.getContractorsWithHttpInfo(id, opts).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * @param {Number} id 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link Object} and HTTP response
     */
  }, {
    key: "getEnergyBreakdownWithHttpInfo",
    value: function getEnergyBreakdownWithHttpInfo(id) {
      var postBody = null;
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling getEnergyBreakdown");
      }
      var pathParams = {
        'id': id
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['ApiAuthorizer', 'ApiKey'];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = Object;
      return this.apiClient.callApi('/schemas/{id}/energy-breakdown', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * @param {Number} id 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link Object}
     */
  }, {
    key: "getEnergyBreakdown",
    value: function getEnergyBreakdown(id) {
      return this.getEnergyBreakdownWithHttpInfo(id).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * @param {Number} id 
     * @param {String} start The date and time in ISO format - YYYY-MM-DD or YYYY-MM-DD HH:mm:ss or YYYY-MM-DDTHH:mm:ss - without a timezone.
     * @param {Object} opts Optional parameters
     * @param {String} opts.end The date and time in ISO format - YYYY-MM-DD or YYYY-MM-DD HH:mm:ss or YYYY-MM-DDTHH:mm:ss - format without a timezone.
     * @param {String} opts.aggregation Suggested aggregation of the data. Is not guaranteed if date range is too large for the aggregation type.
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link Object} and HTTP response
     */
  }, {
    key: "getEnergyDataFeedWithHttpInfo",
    value: function getEnergyDataFeedWithHttpInfo(id, start, opts) {
      opts = opts || {};
      var postBody = null;
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling getEnergyDataFeed");
      }
      // verify the required parameter 'start' is set
      if (start === undefined || start === null) {
        throw new Error("Missing the required parameter 'start' when calling getEnergyDataFeed");
      }
      var pathParams = {
        'id': id
      };
      var queryParams = {
        'start': start,
        'end': opts['end'],
        'aggregation': opts['aggregation']
      };
      var headerParams = {};
      var formParams = {};
      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = Object;
      return this.apiClient.callApi('/schemas/{id}/energy/data-feed', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * @param {Number} id 
     * @param {String} start The date and time in ISO format - YYYY-MM-DD or YYYY-MM-DD HH:mm:ss or YYYY-MM-DDTHH:mm:ss - without a timezone.
     * @param {Object} opts Optional parameters
     * @param {String} opts.end The date and time in ISO format - YYYY-MM-DD or YYYY-MM-DD HH:mm:ss or YYYY-MM-DDTHH:mm:ss - format without a timezone.
     * @param {String} opts.aggregation Suggested aggregation of the data. Is not guaranteed if date range is too large for the aggregation type.
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link Object}
     */
  }, {
    key: "getEnergyDataFeed",
    value: function getEnergyDataFeed(id, start, opts) {
      return this.getEnergyDataFeedWithHttpInfo(id, start, opts).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * @param {Number} id 
     * @param {Object} opts Optional parameters
     * @param {String} opts.timezone Users IANA timezone.
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link Object} and HTTP response
     */
  }, {
    key: "getEnergyLifetimeSummaryWithHttpInfo",
    value: function getEnergyLifetimeSummaryWithHttpInfo(id, opts) {
      opts = opts || {};
      var postBody = null;
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling getEnergyLifetimeSummary");
      }
      var pathParams = {
        'id': id
      };
      var queryParams = {
        'timezone': opts['timezone']
      };
      var headerParams = {};
      var formParams = {};
      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = Object;
      return this.apiClient.callApi('/schemas/{id}/energy/summary/lifetime', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * @param {Number} id 
     * @param {Object} opts Optional parameters
     * @param {String} opts.timezone Users IANA timezone.
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link Object}
     */
  }, {
    key: "getEnergyLifetimeSummary",
    value: function getEnergyLifetimeSummary(id, opts) {
      return this.getEnergyLifetimeSummaryWithHttpInfo(id, opts).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * @param {Object} opts Optional parameters
     * @param {Number} opts.type Type filter.
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link Object} and HTTP response
     */
  }, {
    key: "getListWithHttpInfo",
    value: function getListWithHttpInfo(opts) {
      opts = opts || {};
      var postBody = null;
      var pathParams = {};
      var queryParams = {
        'type': opts['type']
      };
      var headerParams = {};
      var formParams = {};
      var authNames = ['ApiAuthorizer', 'ApiKey'];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = Object;
      return this.apiClient.callApi('/schemas/', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * @param {Object} opts Optional parameters
     * @param {Number} opts.type Type filter.
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link Object}
     */
  }, {
    key: "getList",
    value: function getList(opts) {
      return this.getListWithHttpInfo(opts).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * @param {Number} id 
     * @param {Object} opts Optional parameters
     * @param {String} opts.filter Filter for the name of the site.
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link Object} and HTTP response
     */
  }, {
    key: "getMapSitesWithHttpInfo",
    value: function getMapSitesWithHttpInfo(id, opts) {
      opts = opts || {};
      var postBody = null;
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling getMapSites");
      }
      var pathParams = {
        'id': id
      };
      var queryParams = {
        'filter': opts['filter']
      };
      var headerParams = {};
      var formParams = {};
      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = Object;
      return this.apiClient.callApi('/schemas/{id}/sites/map', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * @param {Number} id 
     * @param {Object} opts Optional parameters
     * @param {String} opts.filter Filter for the name of the site.
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link Object}
     */
  }, {
    key: "getMapSites",
    value: function getMapSites(id, opts) {
      return this.getMapSitesWithHttpInfo(id, opts).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * @param {Number} id 
     * @param {String} slug Slug of the resource.
     * @param {Object} opts Optional parameters
     * @param {String} opts.timezone IANA timezone of the caller to determine the contextual current day. Defaults to Australia/Brisbane; e.g.: Australia/Brisbane
     * @param {Boolean} opts.weather Attach weather if it is a site resource.
     * @param {Boolean} opts.summary Attach summary if it is a site resource.
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link Object} and HTTP response
     */
  }, {
    key: "getResourceBySlugWithHttpInfo",
    value: function getResourceBySlugWithHttpInfo(id, slug, opts) {
      opts = opts || {};
      var postBody = null;
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling getResourceBySlug");
      }
      // verify the required parameter 'slug' is set
      if (slug === undefined || slug === null) {
        throw new Error("Missing the required parameter 'slug' when calling getResourceBySlug");
      }
      var pathParams = {
        'id': id,
        'slug': slug
      };
      var queryParams = {
        'timezone': opts['timezone'],
        'weather': opts['weather'],
        'summary': opts['summary']
      };
      var headerParams = {};
      var formParams = {};
      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = Object;
      return this.apiClient.callApi('/schemas/{id}/resources/{slug}', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * @param {Number} id 
     * @param {String} slug Slug of the resource.
     * @param {Object} opts Optional parameters
     * @param {String} opts.timezone IANA timezone of the caller to determine the contextual current day. Defaults to Australia/Brisbane; e.g.: Australia/Brisbane
     * @param {Boolean} opts.weather Attach weather if it is a site resource.
     * @param {Boolean} opts.summary Attach summary if it is a site resource.
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link Object}
     */
  }, {
    key: "getResourceBySlug",
    value: function getResourceBySlug(id, slug, opts) {
      return this.getResourceBySlugWithHttpInfo(id, slug, opts).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * @param {String} resourceType Resource type; e.g.: organisations or sites.
     * @param {Array.<Number>} ids List of schema IDs.
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link Object} and HTTP response
     */
  }, {
    key: "getResourceTypeCustomAttributesWithHttpInfo",
    value: function getResourceTypeCustomAttributesWithHttpInfo(resourceType, ids) {
      var postBody = null;
      // verify the required parameter 'resourceType' is set
      if (resourceType === undefined || resourceType === null) {
        throw new Error("Missing the required parameter 'resourceType' when calling getResourceTypeCustomAttributes");
      }
      // verify the required parameter 'ids' is set
      if (ids === undefined || ids === null) {
        throw new Error("Missing the required parameter 'ids' when calling getResourceTypeCustomAttributes");
      }
      var pathParams = {
        'resourceType': resourceType
      };
      var queryParams = {
        'ids': this.apiClient.buildCollectionParam(ids, 'multi')
      };
      var headerParams = {};
      var formParams = {};
      var authNames = ['ApiAuthorizer', 'ApiKey'];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = Object;
      return this.apiClient.callApi('/schemas/attributes/resource-types/{resourceType}', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * @param {String} resourceType Resource type; e.g.: organisations or sites.
     * @param {Array.<Number>} ids List of schema IDs.
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link Object}
     */
  }, {
    key: "getResourceTypeCustomAttributes",
    value: function getResourceTypeCustomAttributes(resourceType, ids) {
      return this.getResourceTypeCustomAttributesWithHttpInfo(resourceType, ids).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * @param {Number} id 
     * @param {Object} opts Optional parameters
     * @param {String} opts.timezone IANA timezone of the caller to determine the contextual current day. Defaults to Australia/Brisbane.
     * @param {Number} opts.phase Installation phase of the program.
     * @param {Number} opts.days Number of days to analyse. Defaults to 28.
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link Object} and HTTP response
     */
  }, {
    key: "getSavingsGuaranteeFeedWithHttpInfo",
    value: function getSavingsGuaranteeFeedWithHttpInfo(id, opts) {
      opts = opts || {};
      var postBody = null;
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling getSavingsGuaranteeFeed");
      }
      var pathParams = {
        'id': id
      };
      var queryParams = {
        'timezone': opts['timezone'],
        'phase': opts['phase'],
        'days': opts['days']
      };
      var headerParams = {};
      var formParams = {};
      var authNames = ['ApiAuthorizer', 'ApiKey'];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = Object;
      return this.apiClient.callApi('/schemas/{id}/savings-guarantee/feed', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * @param {Number} id 
     * @param {Object} opts Optional parameters
     * @param {String} opts.timezone IANA timezone of the caller to determine the contextual current day. Defaults to Australia/Brisbane.
     * @param {Number} opts.phase Installation phase of the program.
     * @param {Number} opts.days Number of days to analyse. Defaults to 28.
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link Object}
     */
  }, {
    key: "getSavingsGuaranteeFeed",
    value: function getSavingsGuaranteeFeed(id, opts) {
      return this.getSavingsGuaranteeFeedWithHttpInfo(id, opts).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * @param {Number} id 
     * @param {Object} opts Optional parameters
     * @param {String} opts.timezone IANA timezone of the caller to determine the contextual current day. Defaults to Australia/Brisbane.
     * @param {Number} opts.phase Installation phase of the program.
     * @param {Number} opts.days Number of days to analyse. Defaults to 28.
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link Object} and HTTP response
     */
  }, {
    key: "getSavingsGuaranteeSummaryWithHttpInfo",
    value: function getSavingsGuaranteeSummaryWithHttpInfo(id, opts) {
      opts = opts || {};
      var postBody = null;
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling getSavingsGuaranteeSummary");
      }
      var pathParams = {
        'id': id
      };
      var queryParams = {
        'timezone': opts['timezone'],
        'phase': opts['phase'],
        'days': opts['days']
      };
      var headerParams = {};
      var formParams = {};
      var authNames = ['ApiAuthorizer', 'ApiKey'];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = Object;
      return this.apiClient.callApi('/schemas/{id}/savings-guarantee/summary', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * @param {Number} id 
     * @param {Object} opts Optional parameters
     * @param {String} opts.timezone IANA timezone of the caller to determine the contextual current day. Defaults to Australia/Brisbane.
     * @param {Number} opts.phase Installation phase of the program.
     * @param {Number} opts.days Number of days to analyse. Defaults to 28.
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link Object}
     */
  }, {
    key: "getSavingsGuaranteeSummary",
    value: function getSavingsGuaranteeSummary(id, opts) {
      return this.getSavingsGuaranteeSummaryWithHttpInfo(id, opts).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * @param {Number} id 
     * @param {Object} opts Optional parameters
     * @param {Number} opts.page Page of results to return.
     * @param {Number} opts.limit Limit of results to return.
     * @param {String} opts.filter Filter for the organisation name of the site.
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link Object} and HTTP response
     */
  }, {
    key: "getSitesWithHttpInfo",
    value: function getSitesWithHttpInfo(id, opts) {
      opts = opts || {};
      var postBody = null;
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling getSites");
      }
      var pathParams = {
        'id': id
      };
      var queryParams = {
        'page': opts['page'],
        'limit': opts['limit'],
        'filter': opts['filter']
      };
      var headerParams = {};
      var formParams = {};
      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = Object;
      return this.apiClient.callApi('/schemas/{id}/sites', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * @param {Number} id 
     * @param {Object} opts Optional parameters
     * @param {Number} opts.page Page of results to return.
     * @param {Number} opts.limit Limit of results to return.
     * @param {String} opts.filter Filter for the organisation name of the site.
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link Object}
     */
  }, {
    key: "getSites",
    value: function getSites(id, opts) {
      return this.getSitesWithHttpInfo(id, opts).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * @param {Number} id 
     * @param {Object} opts Optional parameters
     * @param {Number} opts.phase Installation phase to filter by.
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link Object} and HTTP response
     */
  }, {
    key: "getSitesSolarReportWithHttpInfo",
    value: function getSitesSolarReportWithHttpInfo(id, opts) {
      opts = opts || {};
      var postBody = null;
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling getSitesSolarReport");
      }
      var pathParams = {
        'id': id
      };
      var queryParams = {
        'phase': opts['phase']
      };
      var headerParams = {};
      var formParams = {};
      var authNames = ['ApiAuthorizer', 'ApiKey'];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = Object;
      return this.apiClient.callApi('/schemas/{id}/reports/sites-solar', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * @param {Number} id 
     * @param {Object} opts Optional parameters
     * @param {Number} opts.phase Installation phase to filter by.
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link Object}
     */
  }, {
    key: "getSitesSolarReport",
    value: function getSitesSolarReport(id, opts) {
      return this.getSitesSolarReportWithHttpInfo(id, opts).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * @param {Number} id 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link Object} and HTTP response
     */
  }, {
    key: "getSolarCurrentStatsWithHttpInfo",
    value: function getSolarCurrentStatsWithHttpInfo(id) {
      var postBody = null;
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling getSolarCurrentStats");
      }
      var pathParams = {
        'id': id
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = Object;
      return this.apiClient.callApi('/schemas/{id}/solar/stats/current', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * @param {Number} id 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link Object}
     */
  }, {
    key: "getSolarCurrentStats",
    value: function getSolarCurrentStats(id) {
      return this.getSolarCurrentStatsWithHttpInfo(id).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * @param {Number} id 
     * @param {Object} opts Optional parameters
     * @param {String} opts.timezone Users IANA timezone.
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link Object} and HTTP response
     */
  }, {
    key: "getSummaryWithHttpInfo",
    value: function getSummaryWithHttpInfo(id, opts) {
      opts = opts || {};
      var postBody = null;
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling getSummary");
      }
      var pathParams = {
        'id': id
      };
      var queryParams = {
        'timezone': opts['timezone']
      };
      var headerParams = {};
      var formParams = {};
      var authNames = ['ApiKey', 'ApiSoftAuthorizer'];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = Object;
      return this.apiClient.callApi('/schemas/{id}/summary', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * @param {Number} id 
     * @param {Object} opts Optional parameters
     * @param {String} opts.timezone Users IANA timezone.
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link Object}
     */
  }, {
    key: "getSummary",
    value: function getSummary(id, opts) {
      return this.getSummaryWithHttpInfo(id, opts).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * @param {Number} id 
     * @param {String} resourceType Resource type; e.g.: organisations or sites.
     * @param {String} resourceType2 Resource type; e.g.: organisations or sites.
     * @param {String} attributeId ID of the custom attribute.
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link Object} and HTTP response
     */
  }, {
    key: "listResourceTypeCustomAttributeValuesWithHttpInfo",
    value: function listResourceTypeCustomAttributeValuesWithHttpInfo(id, resourceType, resourceType2, attributeId) {
      var _pathParams;
      var postBody = null;
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling listResourceTypeCustomAttributeValues");
      }
      // verify the required parameter 'resourceType' is set
      if (resourceType === undefined || resourceType === null) {
        throw new Error("Missing the required parameter 'resourceType' when calling listResourceTypeCustomAttributeValues");
      }
      // verify the required parameter 'resourceType2' is set
      if (resourceType2 === undefined || resourceType2 === null) {
        throw new Error("Missing the required parameter 'resourceType2' when calling listResourceTypeCustomAttributeValues");
      }
      // verify the required parameter 'attributeId' is set
      if (attributeId === undefined || attributeId === null) {
        throw new Error("Missing the required parameter 'attributeId' when calling listResourceTypeCustomAttributeValues");
      }
      var pathParams = (_pathParams = {
        'id': id,
        'resourceType': resourceType
      }, _defineProperty(_pathParams, "resourceType", resourceType2), _defineProperty(_pathParams, 'attributeId', attributeId), _pathParams);
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['ApiAuthorizer', 'ApiKey'];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = Object;
      return this.apiClient.callApi('/schemas/{id}/attributes/{attributeId}/{resourceType}/values', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * @param {Number} id 
     * @param {String} resourceType Resource type; e.g.: organisations or sites.
     * @param {String} resourceType2 Resource type; e.g.: organisations or sites.
     * @param {String} attributeId ID of the custom attribute.
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link Object}
     */
  }, {
    key: "listResourceTypeCustomAttributeValues",
    value: function listResourceTypeCustomAttributeValues(id, resourceType, resourceType2, attributeId) {
      return this.listResourceTypeCustomAttributeValuesWithHttpInfo(id, resourceType, resourceType2, attributeId).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * @param {Number} id 
     * @param {String} term The search term.
     * @param {Object} opts Optional parameters
     * @param {Number} opts.page Page of results to return.
     * @param {Number} opts.limit Limit of results to return.
     * @param {String} opts.timezone Users IANA timezone.
     * @param {Boolean} opts.extendedDetails Attach extended details to the sites.
     * @param {Boolean} opts.stats Attach stats to the sites.
     * @param {Boolean} opts.weather Attach weather to the sites.
     * @param {String} opts.resourceMode Search mode for returning different types of resources; all (all organisations and sites), organisations (single-sibling sites and organisations with 0 or more than 1 site) or sites (sites only).
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link Object} and HTTP response
     */
  }, {
    key: "searchResourcesWithHttpInfo",
    value: function searchResourcesWithHttpInfo(id, term, opts) {
      opts = opts || {};
      var postBody = null;
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling searchResources");
      }
      // verify the required parameter 'term' is set
      if (term === undefined || term === null) {
        throw new Error("Missing the required parameter 'term' when calling searchResources");
      }
      var pathParams = {
        'id': id
      };
      var queryParams = {
        'term': term,
        'page': opts['page'],
        'limit': opts['limit'],
        'timezone': opts['timezone'],
        'extendedDetails': opts['extendedDetails'],
        'stats': opts['stats'],
        'weather': opts['weather'],
        'resourceMode': opts['resourceMode']
      };
      var headerParams = {};
      var formParams = {};
      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = Object;
      return this.apiClient.callApi('/schemas/{id}/resources', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * @param {Number} id 
     * @param {String} term The search term.
     * @param {Object} opts Optional parameters
     * @param {Number} opts.page Page of results to return.
     * @param {Number} opts.limit Limit of results to return.
     * @param {String} opts.timezone Users IANA timezone.
     * @param {Boolean} opts.extendedDetails Attach extended details to the sites.
     * @param {Boolean} opts.stats Attach stats to the sites.
     * @param {Boolean} opts.weather Attach weather to the sites.
     * @param {String} opts.resourceMode Search mode for returning different types of resources; all (all organisations and sites), organisations (single-sibling sites and organisations with 0 or more than 1 site) or sites (sites only).
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link Object}
     */
  }, {
    key: "searchResources",
    value: function searchResources(id, term, opts) {
      return this.searchResourcesWithHttpInfo(id, term, opts).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * @param {Number} id 
     * @param {String} term The search term.
     * @param {Object} opts Optional parameters
     * @param {Number} opts.page Page of results to return.
     * @param {Number} opts.limit Limit of results to return.
     * @param {String} opts.timezone Users IANA timezone.
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link Object} and HTTP response
     */
  }, {
    key: "searchSitesWithHttpInfo",
    value: function searchSitesWithHttpInfo(id, term, opts) {
      opts = opts || {};
      var postBody = null;
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling searchSites");
      }
      // verify the required parameter 'term' is set
      if (term === undefined || term === null) {
        throw new Error("Missing the required parameter 'term' when calling searchSites");
      }
      var pathParams = {
        'id': id
      };
      var queryParams = {
        'term': term,
        'page': opts['page'],
        'limit': opts['limit'],
        'timezone': opts['timezone']
      };
      var headerParams = {};
      var formParams = {};
      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = Object;
      return this.apiClient.callApi('/schemas/{id}/sites/search', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * @param {Number} id 
     * @param {String} term The search term.
     * @param {Object} opts Optional parameters
     * @param {Number} opts.page Page of results to return.
     * @param {Number} opts.limit Limit of results to return.
     * @param {String} opts.timezone Users IANA timezone.
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link Object}
     */
  }, {
    key: "searchSites",
    value: function searchSites(id, term, opts) {
      return this.searchSitesWithHttpInfo(id, term, opts).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * @param {Number} id 
     * @param {Object} opts Optional parameters
     * @param {String} opts.limit Maximum number of sites to return.
     * @param {String} opts.orderBy Ordering of the result set.
     * @param {String} opts.order Direction of the ordering; defaults to desc.
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link Object} and HTTP response
     */
  }, {
    key: "siteRankingsWithHttpInfo",
    value: function siteRankingsWithHttpInfo(id, opts) {
      opts = opts || {};
      var postBody = null;
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling siteRankings");
      }
      var pathParams = {
        'id': id
      };
      var queryParams = {
        'limit': opts['limit'],
        'orderBy': opts['orderBy'],
        'order': opts['order']
      };
      var headerParams = {};
      var formParams = {};
      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = Object;
      return this.apiClient.callApi('/schemas/{id}/sites/ranking', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * @param {Number} id 
     * @param {Object} opts Optional parameters
     * @param {String} opts.limit Maximum number of sites to return.
     * @param {String} opts.orderBy Ordering of the result set.
     * @param {String} opts.order Direction of the ordering; defaults to desc.
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link Object}
     */
  }, {
    key: "siteRankings",
    value: function siteRankings(id, opts) {
      return this.siteRankingsWithHttpInfo(id, opts).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * @param {Number} id 
     * @param {Object} opts Optional parameters
     * @param {module:model/UpdateSchema} opts.updateSchema Payload for updating a schema.
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link Object} and HTTP response
     */
  }, {
    key: "updateWithHttpInfo",
    value: function updateWithHttpInfo(id, opts) {
      opts = opts || {};
      var postBody = opts['updateSchema'];
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling update");
      }
      var pathParams = {
        'id': id
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['ApiAuthorizer', 'ApiKey'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = Object;
      return this.apiClient.callApi('/schemas/{id}', 'PUT', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * @param {Number} id 
     * @param {Object} opts Optional parameters
     * @param {module:model/UpdateSchema} opts.updateSchema Payload for updating a schema.
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link Object}
     */
  }, {
    key: "update",
    value: function update(id, opts) {
      return this.updateWithHttpInfo(id, opts).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
  }]);
  return SchemasApi;
}();
exports["default"] = SchemasApi;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@solarschools/api-sdk/dist/api/SchemasApi.js
// module id = +VU1
// module chunks = 22